// src/packages/chubb/pa/chubb_pa_series_c_2025/index.js
import ChubbPASeriesCCard from "./ChubbPASeriesCCard";
import ChubbPASeriesCDetails from "./ChubbPASeriesCDetails";
import "./chubb_pa_series_c.css";

/** Chubb — PA Series C (Plans 1–8 + Kid), Effective 2025 */
export default {
  id: "chubb_pa_series_c_2025",
  company: "ชับบ์ (Chubb)",           // ให้ตรงกับ COMPANY_INFO
  productLine: "non-motor",
  categories: ["personal accident", "PA", "health"],
  nameTH: "Chubb PA Series C — แผน 1–8 + Kid",
  description: "ประกันอุบัติเหตุส่วนบุคคล ชุด Series C: คุ้มครองชีวิต/ทุพพลภาพ/ค่ารักษา + ตัวเลือกครอบครัว",
  accent: "#1e3a8a",
  expiresAt: "9999-12-31",
  card: ChubbPASeriesCCard,
  detail: ChubbPASeriesCDetails,
  active: true,
};
